
import type { WithRefs } from 'vue-typed-refs'
import {
  WeveRow,
  WeveCol,
  WeveButton,
  WeveDialog,
  WeveCheckbox,
} from '@weve/ui'

import ConfirmMixin from '../mixins/confirm.mixin'

export default (
  ConfirmMixin as WithRefs<{ accept: HTMLButtonElement }, typeof ConfirmMixin>
).extend({
  name: 'RescheduleEventConfirmDialog',
  components: {
    WeveCheckbox,
    WeveRow,
    WeveCol,
    WeveButton,
    WeveDialog,
  },
  props: {
    title: {
      type: String,
      default: 'Are you sure?',
    },
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    focusAcceptButton() {
      this.$refs.accept.focus()
    },
  },
})
